<template>
  <div class="bussiness-introduction fs">
    <div class="businee-intro">
      <div class="title">{{ $t('homePage.meitongAir') }}</div>
      <img :src="businessIntroImg1">
    </div>
    <div class="businee-intro">
      <div class="title">{{ $t('homePage.meitongShip') }}</div>
      <img :src="businessIntroImg2">
    </div>
    <div class="businee-intro">
      <div class="title">{{ $t('homePage.meitingTruck') }}</div>
      <img :src="businessIntroImg3">
    </div>
    <div class="businee-intro">
      <div class="title">{{ $t('homePage.meitongStorage') }}</div>
      <img :src="businessIntroImg4">
    </div>
  </div>
</template>

<script setup>
const businessIntroImg1 = require('@assets/images/business_intro_1.jpg');
const businessIntroImg2 = require('@assets/images/business_intro_2.jpg');
const businessIntroImg3 = require('@assets/images/business_intro_3.jpg');
const businessIntroImg4 = require('@assets/images/business_intro_4.jpg');

</script>

<style lang="less" scoped>
.bussiness-introduction {
  flex-wrap: wrap;
  gap: 24px;
  .businee-intro {
    flex: 1;
    min-width: 40%;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .title {
      font-size: 24px;
      color: #fff;
      position: absolute;
      top: 26px;
      left: 23px;
    }
  }
}

</style>